import React, { useState } from 'react';
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  InputAdornment,
} from '@mui/material';
import { Search as SearchIcon, KeyboardArrowDown as ArrowDownIcon } from '@mui/icons-material';

const SearchAndFilters = ({ 
  searchTerm, 
  onSearchChange, 
  statusFilter, 
  onStatusFilterChange, 
  repoFilter, 
  onRepoFilterChange 
}) => {
  const formControlStyles = {
    minWidth: 140,
    '& .MuiOutlinedInput-root': {
      borderRadius: 1,
      bgcolor: '#fff',
      '& fieldset': {
        borderColor: '#E2E8F0',
      },
      '&:hover fieldset': {
        borderColor: '#CBD5E1',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1f1f1f',
      },
    },
    '& .MuiSelect-select': {
      py: 1.5,
      fontSize: '0.875rem',
      color: '#475569',
      display: 'flex',
      alignItems: 'center',
    },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: 2, sm: 3 },
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'stretch', md: 'center' },
        width: { xs: '100%', md: 'auto' },
      }}
    >
      {/* Search Bar */}
      <TextField
        placeholder="Search projects..."
        aria-label="Search projects"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{
          flex: 1,
          minWidth: { xs: '100%', md: '60%' },
          '& .MuiOutlinedInput-root': {
            borderRadius: 1,
            minHeight: '40px',
            bgcolor: '#fff',
            '& fieldset': {
              borderColor: '#E2E8F0',
            },
            '&:hover fieldset': {
              borderColor: '#CBD5E1',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1f1f1f',
            },
          },
          '& .MuiInputBase-input': {
            py: 1.5,
            fontSize: '0.875rem',
            '&::placeholder': {
              color: '#94A3B8',
              opacity: 1,
            },
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: '#94A3B8', fontSize: '1.25rem' }} />
            </InputAdornment>
          ),
        }}
      />

      {/* Filter Dropdowns */}
      <Box sx={{ 
        display: 'flex', 
        gap: { xs: 1.5, sm: 2 }, 
        flexDirection: { xs: 'column', sm: 'row' },
        width: { xs: '100%', sm: 'auto' },
        minWidth: { xs: '100%', sm: 'auto' } 
      }}>
        {/* Status Filter */}
        <FormControl
          sx={{
            ...formControlStyles,
            minWidth: { xs: '100%', sm: 140 },
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          <InputLabel
            sx={{
              fontSize: '0.875rem',
              color: '#737373',
              '&.Mui-focused': {
                color: '#1f1f1f',
              },
            }}
          >
            Status
          </InputLabel>
          <Select
            value={statusFilter}
            onChange={(e) => onStatusFilterChange(e.target.value)}
            label="Status"
            IconComponent={ArrowDownIcon}
            sx={{
              minHeight: '40px',
              '& .MuiSelect-icon': {
                color: '#737373',
              },
            }}
            MenuProps={{
              disableScrollLock: true,
              PaperProps: {
                style: {
                  maxHeight: 300,
                },
              },
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
            }}
          >
            <MenuItem value="all">All Projects</MenuItem>
            <MenuItem value="your-projects">Your Projects</MenuItem>
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="inactive">Inactive</MenuItem>
            <MenuItem value="read-only">Read Only</MenuItem>
          </Select>
        </FormControl>

        {/* Repository Filter */}
        <FormControl
          sx={{
            ...formControlStyles,
            minWidth: { xs: '100%', sm: 140 },
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          <InputLabel
            sx={{
              fontSize: '0.875rem',
              color: '#737373',
              '&.Mui-focused': {
                color: '#1f1f1f',
              },
            }}
          >
            Repository
          </InputLabel>
          <Select
            value={repoFilter}
            onChange={(e) => onRepoFilterChange(e.target.value)}
            label="Repository"
            IconComponent={ArrowDownIcon}
            sx={{
              minHeight: '40px',
              '& .MuiSelect-icon': {
                color: '#737373',
              },
            }}
            MenuProps={{
              disableScrollLock: true,
              PaperProps: {
                style: {
                  maxHeight: 300,
                },
              },
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
            }}
          >
            <MenuItem value="all">All Repos</MenuItem>
            <MenuItem value="github">GitHub</MenuItem>
            <MenuItem value="gitlab">GitLab</MenuItem>
            <MenuItem value="bitbucket">Bitbucket</MenuItem>
            <MenuItem value="azure">Azure DevOps</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default SearchAndFilters;